<script>  
    import { Modal, ModalBody, ModalFooter, ModalHeader } from 'sveltestrap';
    
    let object;
    let shown = false;

    const toggle = () => (shown = !shown);
   
    export async function show(objectToView) {
        object = objectToView;
        shown = true;      
    }    
   </script>
   
   <Modal isOpen={shown} {toggle}>
       <ModalHeader {toggle}>
           View Errors
       </ModalHeader>
       <ModalBody>
            <div class="errorContents text-danger">
                {object.errors}
            </div>
       </ModalBody>
       <ModalFooter>
         <button class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>     
       </ModalFooter>
   </Modal>

     <style>
    .errorContents{
        white-space: pre;
    }
   </style>